import { useRedirect } from "../../../../../../global/paywall/useRedirect"
import { useState } from "react"


interface CalcalistPaywallCheckoutFinishProps {
    setShouldRedirect: (shouldRedirect: boolean) => void;
    nextStep: () => void;
}


const CalcalistPaywallCheckoutFinish = (props: CalcalistPaywallCheckoutFinishProps) => {

    const { setShouldRedirect } = props;
    return (
        <div className="CalcalistPaywallCheckoutFinish">
            <h1 className="title">הרכישה הושלמה!</h1>
            <div className="main-container">
                <div className="finish-logo"></div>
                <div className="finish-text">
                    תודה שעשיתם מינוי לעיתון הדיגיטלי של כלכליסט.
                    מוזמנים לעבור למהדורה וליהנות מתוכן מעולה!
                </div>
                <button onClick={() => setShouldRedirect(true)} className="finish-button">לקריאת המהדורה</button>
            </div>
            <div className="checkout-finish-logo"></div>
        </div>
    );
};

export default CalcalistPaywallCheckoutFinish;